module.exports = __webpack_public_path__ + "static/media/2_pl.c31bff07.png";